import parse from 'html-react-parser'
import Image from 'next/image'
import React from 'react'
import readingTime from 'reading-time'
import { ArticleCategoryEnum } from 'ui/src/lib/graphql'

import s from './styles.module.scss'

import { ArticleFooter } from './article-footer/article-footer'
import { ArticleHeader } from './article-header/article-header'
import { Banner } from './banner'
import IconSvg from '../../../atoms/icons/icon-svg/IconSvg'
import { Breadcrumb } from '../../../molecules/breadcrumb/breadcrumb'

type Article = {
  id: string
  title: string
  pathname: string
  author?: {
    name: string
  }
  createdAt?: string
  thumbnail?: {
    src: string
    alt?: string
  }
  body?: string
  categories?: ArticleCategoryEnum[]
}

type ArticleProps = {
  article: Article
  similarArticles: Article[]
}

const ArticleTemplate = ({ article, similarArticles }: ArticleProps) => {
  const { minutes: readTimeInMinutes } = readingTime(article.body ?? '')
  const textBlocks = article.body
    // Remove empty tags from the article content
    ?.replaceAll('<h2><br></h2>', '')
    ?.replaceAll('<h3><br></h3>', '')
    ?.replaceAll('<h4><br></h4>', '')
    ?.replaceAll('<p><br></p>', '')
    // Then split by banner tag to insert the banner component
    ?.split('<p>&lt;banniere&gt;</p>')

  return (
    <div className={s.articleContainer}>
      <article className='container mx-auto max-w-[800px] px-[3vw]'>
        <Breadcrumb>
          <Breadcrumb.Item href='/blog'>Blog</Breadcrumb.Item>
          <Breadcrumb.Item href={`/blog/${article.pathname}`}>
            {article.title}
          </Breadcrumb.Item>
        </Breadcrumb>

        <div className={s.illustration}>
          {article.thumbnail?.src ? (
            <Image
              fill
              src={article.thumbnail.src}
              alt={article.thumbnail?.alt ?? ''}
              priority
              sizes='(max-width: 800px) 100vw, 800px'
            />
          ) : (
            <div className={s.emptyState}>
              <IconSvg.EmptyStateArticles style={{ opacity: '0.1' }} />
            </div>
          )}
        </div>

        <ArticleHeader
          title={article.title}
          author={article.author}
          createdAt={article.createdAt}
          readTimeMinute={readTimeInMinutes}
        />

        <div className={s.articleBody}>
          {textBlocks?.map((block) => (
            <div key={block} className='prose'>
              {parse(block ?? '')}

              <Banner />
            </div>
          ))}
        </div>
      </article>

      <ArticleFooter
        article={{ pathname: article.pathname }}
        similarArticles={similarArticles}
      />
    </div>
  )
}

export { ArticleTemplate as Article }
